/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Stack, Typography, Divider, FormControl, FormLabel } from '@mui/material';
import { useSelector } from 'react-redux';
import { ClientType } from '@/components/cards/DealCardValues/ClientType';
import { GoalsOfCover } from '@/components/cards/DealCardValues/GoalsOfCover';
import { RiskClasses } from '@/components/cards/DealCardValues/RiskClasses';
import { NeedsAnalysisDropdownContainer } from '@/components/cards/DealCardValues/NeedsAnalysisDropdownContainer';
import { AdditionalProducts } from '@/components/cards/DealCardValues/AdditionalProducts';
import { LossReason } from '@/components/cards/DealCardValues/LossReason';
import { PoliciesTab } from './PoliciesTab';
import { MovePolicyTransactionsDialog } from '@/components/dialogs/MoveTransactionDialog';
import RefreshPolicyButton from '@/components/buttons/RefreshPolicyButton';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useGetFormConfigQuery } from '@/features/config/configApi';
import { ReferralStatus } from '@/components/cards/DealCardValues/ReferralStatus';

export const ScopeOfAdviceTab = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const referralFieldsQuery = useGetFormConfigQuery(
		{ configType: 'client' },
		{
			skip: !userDetails,
			selectFromResult: ({ data, ...rest }) => ({
				...rest,
				data:
					data?.filter(
						(f) =>
							['lifeInsuranceReferralStatus', 'kiwiSaverReferralStatus'].includes(
								f.name,
							) && f.visible?.update,
					) ?? [],
			}),
		},
	);
	const referralFields = referralFieldsQuery.data;

	const { dealRow } = useObjectContext();

	const showLossReason = useMemo(() => {
		const pipelineId = dealRow?.pipeline;
		return (
			pipelineId == process.env.REACT_APP_PIPELINE_NEW_BUSINESS ||
			pipelineId == process.env.REACT_APP_PIPELINE_RENEWALS ||
			pipelineId == process.env.REACT_APP_PIPELINE_ENDORSEMENTS
		);
	}, [dealRow?.pipeline]);

	return (
		<Stack spacing={4} width='100%' direction='column'>
			<Stack direction='column' width='100%' spacing={2}>
				<Stack
					direction='row'
					sx={{ justifyContent: 'space-between', alignItems: 'center', pt: '1em' }}
					spacing={1}
					width='100%'
				>
					<Typography variant='form_label'>Policies</Typography>
					<RefreshPolicyButton />
				</Stack>

				<PoliciesTab />
				<MovePolicyTransactionsDialog />
			</Stack>

			<Stack direction='column' width='100%' spacing={2}>
				<Typography variant='form_label'>Scope of advice</Typography>
				<Divider />
				<Stack spacing={5}>
					<ClientType />
					<GoalsOfCover />
					<FormControl>
						<FormLabel>Risk classes considered</FormLabel>
						<RiskClasses />
					</FormControl>
					<NeedsAnalysisDropdownContainer />
					<AdditionalProducts />
					{referralFields.map((field) => (
						<ReferralStatus key={field.name} field={field} minimal={false} />
					))}
					{showLossReason && <LossReason minimal={false} />}
				</Stack>
			</Stack>
		</Stack>
	);
};
